import {
  GET_CAR_DELIVERIES,
  GET_CAR_DELIVERIES_SUCCESS,
  GET_CAR_DELIVERIES_FAIL,
  GET_CAR_DELIVERY_DETAILS,
  GET_CAR_DELIVERY_DETAILS_SUCCESS,
  GET_CAR_DELIVERY_DETAILS_FAIL,
  CREATE_CAR_DELIVERY,
  CREATE_CAR_DELIVERY_SUCCESS,
  CREATE_CAR_DELIVERY_FAIL,
  UPDATE_CAR_DELIVERY,
  UPDATE_CAR_DELIVERY_SUCCESS,
  UPDATE_CAR_DELIVERY_FAIL,
  DELETE_CAR_DELIVERY_SUCCESS,
  DELETE_CAR_DELIVERY_FAIL,
  DELETE_CAR_DELIVERY,

} from "./actionTypes"

// CarDelivery - This line cannot be edited or removed
export const getCarDeliveries = (
  page,
  limit,
  searchText,
  carDeliveryId,

) => ({
  type: GET_CAR_DELIVERIES,
  payload: { page, limit, searchText, carDeliveryId,  },
})

export const getCarDeliveriesSuccess = carDeliverys => ({
  type: GET_CAR_DELIVERIES_SUCCESS,
  payload: carDeliverys,
})

export const getCarDeliveriesFail = error => ({
  type: GET_CAR_DELIVERIES_FAIL,
  payload: error,
})

export const getCarDeliveryDetails = carDeliveryId => ({
  type: GET_CAR_DELIVERY_DETAILS,
  payload: carDeliveryId,
})

export const getCarDeliveryDetailsSuccess = carDeliveryDetails => ({
  type: GET_CAR_DELIVERY_DETAILS_SUCCESS,
  payload: carDeliveryDetails,
})

export const getCarDeliveryDetailsFail = error => ({
  type: GET_CAR_DELIVERY_DETAILS_FAIL,
  payload: error,
})

export const createCarDelivery = (carDelivery, onCloseClick) => ({
  type: CREATE_CAR_DELIVERY,
  payload: { carDelivery, onCloseClick },
})

export const createCarDeliverySuccess = carDelivery => ({
  type: CREATE_CAR_DELIVERY_SUCCESS,
  payload: carDelivery,
})

export const createCarDeliveryFail = error => ({
  type: CREATE_CAR_DELIVERY_FAIL,
  payload: error,
})

export const getCarDeliveryDetail = carDeliveryId => ({
  type: GET_CAR_DELIVERY_DETAILS,
  payload: carDeliveryId,
})

export const updateCarDelivery = (carDelivery, carDeliveryId, onCloseClick) => ({
  type: UPDATE_CAR_DELIVERY,
  payload: { carDelivery, carDeliveryId, onCloseClick },
})

export const updateCarDeliverySuccess = carDelivery => ({
  type: UPDATE_CAR_DELIVERY_SUCCESS,
  payload: carDelivery,
})

export const updateCarDeliveryFail = error => ({
  type: UPDATE_CAR_DELIVERY_FAIL,
  payload: error,
})

export const deleteCarDelivery = carDeliveryId => ({
  type: DELETE_CAR_DELIVERY,
  payload: { carDeliveryId },
})

export const deleteCarDeliverySuccess = carDelivery => ({
  type: DELETE_CAR_DELIVERY_SUCCESS,
  payload: carDelivery,
})

export const deleteCarDeliveryFail = error => ({
  type: DELETE_CAR_DELIVERY_FAIL,
  payload: error,
})
